export default <circle cx="16" cy="16" r="11" fill="none" stroke="#1A1A1A"/>;
